/*
 * Dockside header: the dropdowns, the small-screen menu panel and the homepage header's solid state.
 * Also the catalog's Filter and Sort: Esc closes them, a click elsewhere closes Sort, and one is open at a time.
 * Listeners sit on the document, so they keep working when the theme editor re-renders the section.
 */
(() => {
  if (window.dsiHeaderReady) return;
  window.dsiHeaderReady = true;

  const root = document.documentElement;

  // ---------- Menu panel (under 990px) ----------

  const panel = () => document.getElementById('DsiMenuPanel');

  const openPanel = () => {
    const dialog = panel();
    if (!dialog || dialog.open) return;
    dialog.showModal();
    root.classList.add('dsi-locked');
  };

  const closePanel = () => {
    const dialog = panel();
    if (dialog && dialog.open) dialog.close();
  };

  // ---------- Dropdowns (CSS opens them on hover and focus; Esc needs a script) ----------

  const parentItem = (target) => (target instanceof Element ? target.closest('.dsi-nav__item--parent') : null);

  const isOpen = (item) => !item.classList.contains('is-dismissed') && item.matches(':hover, :focus-within');

  const syncExpanded = (item) => {
    const link = item.querySelector(':scope > a');
    if (link) link.setAttribute('aria-expanded', String(isOpen(item)));
  };

  const dismissOpenDropdowns = () => {
    document.querySelectorAll('.dsi-nav__item--parent').forEach((item) => {
      if (!isOpen(item)) return;
      item.classList.add('is-dismissed');
      if (item.contains(document.activeElement)) item.querySelector(':scope > a').focus();
      syncExpanded(item);
    });
  };

  // ---------- Cart count (Dawn's cart page removes items without reloading) ----------

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
      if (!cartData) return;
      document.querySelectorAll('[data-dsi-cart-count]').forEach((count) => {
        count.textContent = cartData.item_count;
      });
    });
  }

  // ---------- Homepage header: solid as soon as the photograph starts to move up ----------
  // The reveal pins the photograph until the end of its scroll track, where the bottom of .dsi-hero meets the
  // bottom of the screen. Past that point the photograph slides up, under a solid header.

  // Both elements are looked up each time, so this keeps working when the theme editor re-renders a section.
  let solidQueued = false;
  const syncSolid = () => {
    solidQueued = false;
    const overlay = document.querySelector('[data-dsi-overlay]');
    const hero = document.querySelector('.dsi-hero');
    if (!overlay) return;
    overlay.classList.toggle('is-solid', !hero || hero.getBoundingClientRect().bottom < window.innerHeight - 1);
  };
  const queueSolid = () => {
    if (solidQueued) return;
    solidQueued = true;
    window.requestAnimationFrame(syncSolid);
  };
  window.addEventListener('scroll', queueSolid, { passive: true });
  window.addEventListener('resize', queueSolid);
  document.addEventListener('shopify:section:load', queueSolid);
  syncSolid();

  // ---------- Listeners ----------

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-dsi-menu-open]')) openPanel();
    if (event.target.closest('[data-dsi-menu-close]')) closePanel();
    // A link such as /#concierge stays on the page, so the panel has to close itself.
    if (event.target.closest('#DsiMenuPanel a')) closePanel();
    document.querySelectorAll('[data-dsi-sort][open]').forEach((sort) => {
      if (!sort.contains(event.target)) sort.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    dismissOpenDropdowns();
    document.querySelectorAll('[data-dsi-filter][open], [data-dsi-sort][open]').forEach((control) => {
      control.open = false;
      control.querySelector('summary').focus();
    });
  });

  // Opening Sort closes Filter, and the other way round. The toggle event doesn't bubble.
  document.addEventListener(
    'toggle',
    (event) => {
      const opened = event.target;
      if (!(opened instanceof Element) || !opened.open || !opened.matches('[data-dsi-sort], [data-dsi-filter]')) return;
      document.querySelectorAll('[data-dsi-sort][open], [data-dsi-filter][open]').forEach((other) => {
        if (other !== opened) other.open = false;
      });
    },
    true
  );

  // The dialog's close event doesn't bubble, and also fires when Esc closes the panel.
  document.addEventListener(
    'close',
    (event) => {
      if (event.target === panel()) root.classList.remove('dsi-locked');
    },
    true
  );

  document.addEventListener('focusin', (event) => {
    const item = parentItem(event.target);
    if (item) syncExpanded(item);
  });

  document.addEventListener('focusout', (event) => {
    const item = parentItem(event.target);
    if (!item) return;
    if (!item.contains(event.relatedTarget)) item.classList.remove('is-dismissed');
    window.requestAnimationFrame(() => syncExpanded(item));
  });

  document.addEventListener(
    'mouseenter',
    (event) => {
      if (event.target instanceof Element && event.target.matches('.dsi-nav__item--parent')) syncExpanded(event.target);
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    (event) => {
      if (!(event.target instanceof Element) || !event.target.matches('.dsi-nav__item--parent')) return;
      event.target.classList.remove('is-dismissed');
      window.requestAnimationFrame(() => syncExpanded(event.target));
    },
    true
  );

  window.matchMedia('(min-width: 990px)').addEventListener('change', closePanel);
})();
